import React from 'react';
import ReactDOM from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import App from '@/App';
import {
  LAUNCH_DARKLY_CLIENT_SIDE_ID,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  ENV,
} from '@/env-variables';
import { initializeDatadog } from '@/services/datadog/datadogInit';
import { queryClient } from '@/routes';
import { getClientEnvs } from '@/services/clientEnv-service/clientEnv-service';

import '@scholastic/mockingjay/variables.css';
import '@scholastic/mockingjay/styles.css';
import 'eds-common/styles.css';
import '@scholastic/eds-mediaplayers/styles.css';
import '@/index.css';

(async () => {
  const clientEnvs = await getClientEnvs();

  queryClient.setQueryData(['clientEnvs'], clientEnvs);

  await (async () => {
    if (clientEnvs?.env === 'dev') {
      const { worker } = await import('./mocks/browser');
      await worker.start({
        onUnhandledRequest: 'bypass',
      });
    }
  })().catch((e) => console.error(e));

  const LDProvider = await asyncWithLDProvider({
    clientSideID:
      clientEnvs?.launchDarklyClientSideId ?? LAUNCH_DARKLY_CLIENT_SIDE_ID,
    context: {
      kind: 'user',
      key: 'staticKey',
    },
  });

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <LDProvider>
        <App />
      </LDProvider>
    </React.StrictMode>
  );

  await initializeDatadog(
    clientEnvs?.datadogRumApplicationId ?? DATADOG_RUM_APPLICATION_ID,
    clientEnvs?.datadogRumClientToken ?? DATADOG_RUM_CLIENT_TOKEN,
    clientEnvs?.env ?? ENV
  );
})().catch((e) => {
  console.error(e);
});
